import { call, put, takeLatest } from "redux-saga/effects";
import { get } from "lodash";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload } from "shared-utility/store/utils/helpers";

import uploadFile from "../../../../helpers/sourceFileUploadHelper";

// ACTIONS
export const SET_LENDER_REPORTING_SF_VERSIONS_SELECTIONS = generateDefaultActions("SET_LENDER_REPORTING_SF_VERSIONS_SELECTIONS");
export const setSourceFileVersionsSelections = payload => makeWritePayload(SET_LENDER_REPORTING_SF_VERSIONS_SELECTIONS.value, payload);

export const UPLOAD_SOURCE_FILE_VERSION = generateDefaultActions("UPLOAD_SOURCE_FILE_VERSION");
export const uploadSourceFileVersion = (selectedSourceFile, userId, file, companyId) => makePayload(UPLOAD_SOURCE_FILE_VERSION.value, {
  dealId: selectedSourceFile.dealId,
  propertyId: selectedSourceFile.propertyId,
  userId,
  sourceId: selectedSourceFile.sourceId,
  typeId: selectedSourceFile.typeId,
  parentId: selectedSourceFile.typeId === "rent-roll" || selectedSourceFile.typeId === "mf-rent-roll" || selectedSourceFile.typeId === "mf-rent-roll-charge-code" ? "" : selectedSourceFile.id,
  file,
  isPortfolioLevel: selectedSourceFile.isPortfolioLevel,
  companyId
});
function* uploadSourceFileVersionSaga(payload) {
  try {
    const url = (payload.typeId === "rent-roll" || payload.typeId === "mf-rent-roll" || payload.typeId === "mf-rent-roll-charge-code") ? "/rent-rolls/upload" : "/source-files";
    const response = yield call(uploadFile, { ...payload, url }, "POST");
    yield put({ type: UPLOAD_SOURCE_FILE_VERSION.success, payload: response });
  } catch (error) {
    const userFriendlyError = get(error, "response.data.error", "Upload encountered error. Please choose a different file and try again.");
    yield put({ type: UPLOAD_SOURCE_FILE_VERSION.failure, payload: { userFriendlyError, error } });
  }
}

export const actionCreators = {
  setSourceFileVersionsSelections,
  uploadSourceFileVersion
};

// REDUCER
const initialState = {
  isConfirmDialogOpen: false,
  isOverriding: false,
  isUploading: false,
  selectedVersion: null,
  sourceFileDetails: null,
  uploadErrorMessage: null,
  uploadSuccessful: false,
  isOpen: false,
  largeMriFileModal: false
};

export function lenderReportingSFVersionsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_LENDER_REPORTING_SF_VERSIONS_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case UPLOAD_SOURCE_FILE_VERSION.value:
      return { ...state, isUploading: true };
    case UPLOAD_SOURCE_FILE_VERSION.success:
      return { ...state, isUploading: false, uploadErrorMessage: null, uploadSuccessful: true, sourceFileDetails: payload.data,
        largeMriFileModal: payload.largeMriFile || false };
    case UPLOAD_SOURCE_FILE_VERSION.failure:
      return { ...state, isUploading: false, uploadErrorMessage: "Upload failed, please try again", uploadSuccessful: false };

    default:
      return state;
  }
}

// SAGA
export function* lenderReportSourceFileVersionsSaga() {
  yield takeLatest(UPLOAD_SOURCE_FILE_VERSION.value, uploadSourceFileVersionSaga);
}
